export const Status = [
    { id: 'active', name: 'Active' },
    { id: 'blocked',  name: 'Blocked' },
];

